import { useGetStatementTitleGroupsStatementTitlesQuery } from "redux/api/reconciliationsApiSlice";
import { useStatementsTitlesTable } from "../../../context/StatementTitlesTableContext";
import StatementTitlesTable from "./StatementTitlesTable";

export const StatementTitleGroupStatementTitlesTable = ({ statementTitleGroup }: { statementTitleGroup: string }) => {

  const { page, setPage, pageSize, setPageSize } = useStatementsTitlesTable();

  const { data: linkedStatements, isLoading, isFetching } = useGetStatementTitleGroupsStatementTitlesQuery({ uuid: statementTitleGroup, page: page, page_size: pageSize });

  return (

    <StatementTitlesTable
      tableProps={{
        loading: isLoading || isFetching,
        dataSource: linkedStatements?.results,
        pagination: {
          current: page,
          pageSize: pageSize,
          showSizeChanger: true,
          total: (linkedStatements?.count) ?? 0,
          showTotal: (total, range) => `${range[0]}-${range[1]} di ${total} titoli`,
          onChange: (page, pageSize) => {
            setPage(page);
            setPageSize(pageSize);
          },
          position: ["bottomLeft"],
        }
      }} />
  );
};